import { createFileRoute } from "@tanstack/react-router";
import { Card, PageHeading } from "@/ui";
import { BouncesTable } from "#/components/bounces/BouncesTable";

export const Route = createFileRoute(
  "/dashboard/w/$workspaceId/sending/bounces",
)({
  component: BouncesPage,
});

// The single card on the page carries no title of its own: the
// `<h1>` above it already names the one thing here, and a "Bounces" card
// under an "Email bounces" heading reads as two names for one list. Same
// shape as `sending/templates.tsx` and `sending/events.tsx`.
function BouncesPage() {
  const { workspaceId } = Route.useParams();

  return (
    <div className="flex flex-col gap-6">
      <PageHeading title="Email bounces" />
      <Card>
        <div className="flex flex-col gap-2">
          <BouncesTable workspaceId={workspaceId} />
          <p className="text-xs" style={{ color: "var(--gs-muted)" }}>
            A hard bounce suppresses the address everywhere, including your subscriber list. Soft
            bounces retry and are not suppressed.
          </p>
        </div>
      </Card>
    </div>
  );
}
